import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { ScrollArea } from "@/components/ui/scroll-area";
import { FormOfSurrender } from "@/types";

interface FormOfSurrenderCardProps {
  formOfSurrenders: FormOfSurrender[];
  notes?: string;
}

export function FormOfSurrenderCard({ formOfSurrenders, notes }: FormOfSurrenderCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Form of Surrender</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {formOfSurrenders && formOfSurrenders.length > 0 ? (
          <ScrollArea className="h-[200px]">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Agreement Number</TableHead>
                  <TableHead>Product</TableHead>
                  <TableHead>Week</TableHead>
                  <TableHead>Points</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {formOfSurrenders.map((entry, index) => (
                  <TableRow key={entry._id ?? `form-of-surrender-${index}`}>
                    <TableCell>{entry.agreementNumber}</TableCell>
                    <TableCell>{entry.product}</TableCell>
                    <TableCell>{entry.week ?? '-'}</TableCell>
                    <TableCell>{entry.points ?? '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ScrollArea>
        ) : (
          <div className="text-center py-4 text-muted-foreground">
            No form of surrender entries found
          </div>
        )}

        {notes && (
          <div className="text-sm text-muted-foreground whitespace-pre-line p-4 bg-accent/50 rounded-lg">
            {notes}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
